/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { logoutUserFulfill, selectCustomerFulfill } from 'actions';
import { connectRouter } from 'connected-react-router';
import type { History } from 'history';
import { combineReducers } from 'redux';
import agentSessions from './agentSessions';
import alerts from './alerts';
import analytics from './analytics';
import annotator from './annotator';
import annotatorsAuditLogs from './annotatorsAuditLogs';
import assignments from './assignments';
import auditLogs from './auditLogs';
import auth from './auth';
import bulkOutcomes from './bulkOutcomes';
import campaign from './campaign';
import campaignRuleOutcomes from './campaignRuleOutcomes';
import categories from './category';
import cohorts from './cohorts';
import communication from './communication';
import config from './config';
import customReports from './customReports';
import customerContacts from './customerContacts';
import customers from './customers';
import dashboard from './dashboard';
import dashboardEdit from './dashboardEdit';
import entities from './entities';
import envelopeActions from './envelopeActions';
import envelopeListView from './envelopeListView';
import envelopeReview from './envelopeReview';
import envelopeView from './envelopeView';
import envelopes from './envelopes';
import events from './events';
import fileUploads from './fileUploads';
import identifier from './identifier';
import identities from './identities';
import importFlow from './import';
import integrationSettings from './integrationSettings';
import invitations from './invitations';
import models from './model';
import nav from './nav';
import notifications from './notifications';
import outcome from './outcome';
import permissions from './permissions';
import promptTemplates from './promptTemplates';
import relationship from './relationship';
import rule from './rule';
import ruleGroups from './ruleGroups';
import rulesAuditLogs from './rulesAuditLogs';
import savedSearches from './savedSearches';
import socketState from './socketState';
import tagGroups from './tagGroups';
import tags from './tags';
import tasks from './tasks';
import teams from './teams';
import templates from './templates';
import testCases from './testCases';
import useCasePage from './useCasePage';
import userPermissionsPage from './userPermissionsPage';
import userProfilePage from './userProfilePage';
import users from './users';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createRootReducer = (history: History) => {
  const ui = combineReducers({
    envelopeListView,
    envelopeView,
    importFlow,
    useCasePage,
    userPermissionsPage,
    userProfilePage,
  });

  const appReducer = combineReducers({
    router: connectRouter(history),

    // app
    ui,
    nav,
    agentSessions,
    alerts,
    analytics,
    annotator,
    annotatorsAuditLogs,
    assignments,
    auditLogs,
    auth,
    bulkOutcomes,
    campaign,
    campaignRuleOutcomes,
    categories,
    cohorts,
    communication,
    config,
    customerContacts,
    customReports,
    dashboard,
    dashboardEdit,
    entities,
    envelopeActions,
    envelopes,
    envelopeReview,
    events,
    fileUploads,
    identifier,
    identities,
    integrationSettings,
    invitations,
    models,
    notifications,
    outcome,
    permissions,
    promptTemplates,
    relationship,
    rule,
    rulesAuditLogs,
    ruleGroups,
    savedSearches,
    socketState,
    tags,
    tagGroups,
    tasks,
    teams,
    templates,
    testCases,
    users,
    customers,
  });

  const rootReducer: typeof appReducer = (state, action) => {
    if (action.type === logoutUserFulfill.toString()) {
      if (state) return appReducer({ router: state.router } as GlobalState, action);
    }

    if (action.type === selectCustomerFulfill.toString()) {
      if (state)
        return appReducer(
          {
            router: state.router,
            auth: state.auth,
            ui: {
              envelopeListView: state.ui.envelopeListView,
              envelopeView: state.ui.envelopeView,
              importFlow: state.ui.importFlow,
              useCasePage: state.ui.useCasePage,
            },
          } as GlobalState,
          action
        );
    }

    return appReducer(state, action);
  };

  return rootReducer;
};

export type RootReducer = ReturnType<typeof createRootReducer>;
export type GlobalState = ReturnType<ReturnType<typeof createRootReducer>>;

export default createRootReducer;
